
import { useState, useEffect } from 'react'
import { Modal, Form, Input, Tree, notification } from 'antd';
import axios from 'axios';
import axiosConfig from '../../configs/axios.config';

const PermissionDetail = (props) => {
    const {open, type, setOpen, detailData=undefined,reloadPage} = props
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [treeData, setTreeData] = useState([])
    const [dataForm, setDataForm] = useState({})
    const [form] = Form.useForm()
    const [checkedKeys, setCheckedKeys] = useState([])
    const validateMessages = {
        required: '${label} không được để trống',
        types: {
        email: '${label} phải là một email!',
        }
    };


    useEffect(() => {
        setIsModalOpen(open);
        setCheckedKeys([])
    }, [open]);
    const handleCancel = () => {
        setOpen(false);
        setCheckedKeys([])
        form.resetFields()
    };
    const onCheck = (checkedKeysValue) => {
        setCheckedKeys(checkedKeysValue)
    }
    const listPermission = async () => {
      const response = axios.create(axiosConfig).get('/api/roleDefault')
      response
        .then((response) => {
          if(response.status !== 200 && !response.data) {
              return notification.warning({
                  message: response.data.message || "Lỗi hệ thống",
              })
          }
          // const {}
          setTreeData(response.data.data)
        })
        .catch((error) => {
            console.log(error);
            return notification.warning({
                message: error || "Hệ thống đang bảo trì, vui lòng thử lại sau!",
            })
        })
  }

    const detailPermission =  () =>{
        if(detailData){
          const { id, name, description, list } = detailData
          const dataform = {
            id,
            name,
            description
          }
          setDataForm(dataform)
          form.setFieldsValue(dataform)
          setCheckedKeys(list)
          
        }
    }
    const onCreact = async () =>{
        if(type === 'CREATE'){
            await form.validateFields()
            const { name,description } = form.getFieldValue() 
            let roles = ""
            checkedKeys.forEach((item, index) => {
              roles += `'`+item+`'`+(index === checkedKeys.length-1 ? '' : `,`)

            })
            const body = {
                name,
                description:!description?.length ? ' ':description,
                roleIds: roles ? roles : "",
            }
            const response = axios.create(axiosConfig).post('/api/groupRoles', body)
            response
              .then((response) => {
                if(response.status !== 200 && !response.data) {
                    return notification.warning({
                        message: response.data.message || 'Tạo nhóm phân quyền thất bại vui lòng thử lại!',
                    })
                }
                notification.success({ message: response.data.message || "Thành công" })
              })
              .catch((error) => {
                  console.log(error);
                  return notification.warning({
                      message: error || 'Hệ thống đang bảo trì, vui lòng thử lại sau!',
                  })
              })
          setOpen(false);
          reloadPage();
          form.resetFields()
        }
        if(type === 'UPDATE'){
          await form.validateFields()
          const { name,description } = form.getFieldValue() 
          let roles = ""
          checkedKeys.forEach((item, index) => {
            console.log(item);
            roles += `'`+item+`'`+(index === checkedKeys.length-1 ? '' : `,`)

          })
          const body = {
              name,
              description:!description?.length ? ' ':description,
              roleIds: roles && roles,
          }
          body.id = dataForm.id
          const response = axios.create(axiosConfig).put('/api/groupRoles', body)
          response
            .then((response) => {
              if(response.status !== 200 && !response.data) {
                  return notification.warning({
                      message: response.data.message || 'Chỉnh sửa nhóm phân quyền thất bại vui lòng thử lại!',
                  })
              } 
              notification.success({ message: response.data.message || "Thành công" })
            })
            .catch((error) => {
                console.log(error);
                form.resetFields()
                return notification.warning({
                    message: error || "Hệ thống đang bảo trì, vui lòng thử lại sau!",
                })
            })

          setOpen(false);
          reloadPage();
          form.resetFields()
        }
    }
    useEffect(()=>{
      detailPermission()
    },[detailData])
    useEffect(()=>{
      listPermission()
    },[])
    return (
        <>
                <Modal 
                    title={type === 'CREATE' ? 'Tạo nhóm phân quyền mới' : 'Chỉnh sửa nhóm phân quyền'} 
                    visible={isModalOpen} onOk={() => {onCreact();}} onCancel={handleCancel}
                    width={'80vw'} style={{margin: '0 auto', }}>
                <div style={{display: 'flex', gap:"10px", }}>
                <Form style={{width: '50%'}} form={form} layout={'vertical'} validateMessages={validateMessages} 
                initialValues={{key:'EMPLOYEE'}}>
                    <Form.Item
                        label="Tên nhóm"
                        name="name"
                        rules={[{required: true }]}
                        >
                        <Input placeholder="Nhập tên nhóm" />
                    </Form.Item>
                    <Form.Item label="Ghi chú" name="description" >
                        <Input.TextArea showCount maxLength={300} autoSize={{ minRows: 3, maxRows: 5 }} />
                    </Form.Item>
                </Form>
                <div style={{width: '45%',maxHeight: '70vh', overflowY: 'auto',overflowX: 'hidden'}}>
                    <Tree  
                      style={{ marginTop: 10, marginLeft: 10, width: '100%' }}
                      defaultExpandAll={true}
                      checkable
                      checkedKeys={checkedKeys}
                      onCheck={onCheck}
                      treeData={treeData}
                    />  

                </div>
                
                </div>
            </Modal>
        </>
      


    )

}

export default PermissionDetail